<template>
  <div class="index-containter">
    <nav-menu></nav-menu>
    <div class="index-body">
      <div class="index-bond">
        <el-carousel height="300px">
          <el-carousel-item class="one">
            <div class="title">经纬瓷都中小企服务平台</div>
            <div class="des">互联网+电子保函 综合服务提供商</div>
          </el-carousel-item>
          <el-carousel-item class="two">
            <div class="title">经纬瓷都中小企服务平台</div>
            <div class="des">互联网+电子保函 综合服务提供商</div>
          </el-carousel-item>
          <el-carousel-item class="three">
            <div class="title">经纬瓷都中小企服务平台</div>
            <div class="des">互联网+电子保函 综合服务提供商</div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="notice">
        <div>
          <img src="@/assets/msg.png" alt="">
          <span>公告：<span @click="toDetail(noticeList[0].id)">{{ noticeList[0] ? noticeList[0].name : '' }}</span></span>
        </div>
        <span @click="toNotice" class="more">查看更多</span>
      </div>
      <div class="containter" style="padding: 10px 30px 10px;">
        <div class="bh-box">
          <div class="bh-title">保函服务</div>
          <div class="bh-intro">涵盖5大类 足不出户 线上办保函</div>
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide swiper-no-swiping">
                <div class="big">
                  <img src="@/assets/icon5.png" alt="">
                </div>
                <div class="title">工程预付款保函</div>
                <div class="cont">工程预付款保函简介语</div>
                <div class="detail">
                  工程质量保函，也称为"维修保函"，是指应供货方或承建人申请，向买方或业主保证，如货物或工程的质量不符合合同约定而卖方或承建人又不能依约更换或修理时，按买方或业主的索赔予以赔偿的书面文件。质量保函
                </div>
                <div class="small">
                  <img src="@/assets/num5.png" alt="">
                </div>
                <a class="apply" href="https://lynmg.jingweicd.com">
                  <span>现在申请</span>
                  <i class="el-icon-right"></i>
                </a>
              </div>
              <div class="swiper-slide swiper-no-swiping">
                <div class="big">
                  <img src="@/assets/icon1.png" alt="">
                </div>
                <div class="title">工程投标保函</div>
                <div class="cont">工程投标保函简介语</div>
                <div class="detail">
                  投标人购买投标保函等同于缴纳投标保证金，是在通过招标方式成交的工程建造和物资采购等项目中，投标方为响应招标方的要求，向保证人申请出具的保函，保证投标方履行招标文件的一种保函</div>
                <div class="small">
                  <img src="@/assets/num1.png" alt="">
                </div>
                <a class="apply" :href="url + 'project?time=' + new Date().getTime()">
                  <span>现在申请</span>
                  <i class="el-icon-right"></i>
                </a>
              </div>
              <div class="swiper-slide swiper-no-swiping">
                <div class="big">
                  <img src="@/assets/icon2.png" alt="">
                </div>
                <div class="title">工程履约银保</div>
                <div class="cont">工程履约银保简介语</div>
                <div class="detail">
                  向建设工程发包人提供的保证承包人履行建设合同义务的保函，是担保人应被保证人申请向工程承包项目中的业主或商品买卖中的买方出具的，保证被保证人严格按照合同约定全面和实际地履行其合同责任和义务的一种保函。
                </div>
                <div class="small">
                  <img src="@/assets/num2.png" alt="">
                </div>
                <a class="apply" href="https://lynmg.jingweicd.com">
                  <span>现在申请</span>
                  <i class="el-icon-right"></i>
                </a>
              </div>
              <div class="swiper-slide swiper-no-swiping">
                <div class="big">
                  <img src="@/assets/icon3.png" alt="">
                </div>
                <div class="title">工程质量保函</div>
                <div class="cont">工程质量保函简介语</div>
                <div class="detail">
                  工程质量保函，也称为"维修保函"，是指应供货方或承建人申请，向买方或业主保证，如货物或工程的质量不符合合同约定而卖方或承建人又不能依约更换或修理时，按买方或业主的索赔予以赔偿的书面文件。质量保函
                </div>
                <div class="small">
                  <img src="@/assets/num3.png" alt="">
                </div>
                <a class="apply" href="https://lynmg.jingweicd.com">
                  <span>现在申请</span>
                  <i class="el-icon-right"></i>
                </a>
              </div>
              <div class="swiper-slide swiper-no-swiping">
                <div class="big">
                  <img src="@/assets/icon4.png" alt="">
                </div>
                <div class="title">农民工工资保函</div>
                <div class="cont">农民工工资保函简介语</div>
                <div class="detail">是指在建筑工程项目中为保证建设单位如期履行农民工工资支付义务，由担保人为建设单位向监管人提供的，保证建设单位如期履行农民工工资支付义务的担保。</div>
                <div class="small">
                  <img src="@/assets/num4.png" alt="">
                </div>
                <a class="apply" href="https://lynmg.jingweicd.com">
                  <span>现在申请</span>
                  <i class="el-icon-right"></i>
                </a>
              </div>
            </div>
            <div class="swiper-pagination" v-show="false"></div>
          </div>
        </div>
        <div class="index-guarantee">
          <img src="@/assets/stepbg.png" alt="" />
        </div>
        <div class="index-data">
          <div class="data-head"><img src="./../assets/statistical.png" alt=""></div>
          <div class="data-analysis">
            <p>数据分析</p>
          </div>
          <div class="data-des">——— 线上办理、方便快捷、值得信赖 ———</div>
          <div class="data-list flex-a flex-b">
            <div class="data-item" v-for="(item, index) in dataList" :key="item.id">
              <div v-if="index == 0"><img src="./../assets/total.png" alt=""></div>
              <div v-if="index == 1"><img src="./../assets/user.png" alt=""></div>
              <div v-if="index == 2"><img src="./../assets/business.png" alt=""></div>
              <div v-if="index == 3"><img src="./../assets/cooperation.png" alt=""></div>
              <div class="num">{{ item.num }}</div>
              <div class="name">{{ item.name }}</div>
            </div>
          </div>
        </div>
        <div class="news-list">
          <div class="news-title">
            <div class="news-big-title">行业资讯</div>
            <div class="flex-a news-sub-title"><span class="line"></span> <span>Industry information</span> <span
                class="line"></span></div>
          </div>
          <div class="news-item-box" v-for="(item, index) in newsList" :key="index" @click="toDetail(item.id)">
            <div class="news-item flex-a flex-b">
              <div class="news-left">
                <div class="news-left-box">
                  <div class="news-item-day">{{ item.createTime ? item.createTime.split(' ')[0].split('-')[2] : '' }}
                  </div>
                  <div class="news-item-year">{{ item.createTime ? item.createTime.split(' ')[0].split('-')[0] + '-'
                    + item.createTime.split(' ')[0].split('-')[1] : ''
                    }}</div>
                </div>
              </div>
              <div class="news-right">
                <div class="news-item-title">{{ item.name }}</div>
                <div class="news-item-des">{{ item.remark }} </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <foot></foot>
  </div>
</template>

<script>
import 'swiper/dist/idangerous.swiper.css'
import Swiper from 'swiper/dist/idangerous.swiper.js'
import { getInfo, getInfoByToken, getProduct, getProductByToken, getDataInfo, getDataInfoByToken } from './../lib/api/index'
export default {
  name: 'index',
  components: {
  },
  data() {
    return {
      btn: 1,
      newsList: [],
      noticeList: [],
      productList: [],
      dataList: [],
      url: window.location.href
    }
  },
  created() {
    console.log(window.localStorage.getItem("token"))
    if (window.localStorage.getItem("token")) {
      this.getInfoByToken()
      this.getProductByToken({ pageNum: 1, pageSize: 10 })
      this.getDataInfoByToken()
    } else {
      this.getInfo()
      this.getProduct({ pageNum: 1, pageSize: 10 })
      this.getDataInfo()
    }
  },
  mounted: function () {
    let vm = this;
    let mySwiper = new Swiper('.swiper-container', {
      pagination: '.swiper-pagination',
      slidesPerView: 5,
      paginationClickable: true,
      spaceBetween: 30,
      freeMode: true,
      noSwiping: true,
    })
  },
  methods: {
    //查看首页资讯，通知----未登录
    getInfo() {
      getInfo().then(res => {
        console.log(res)
        if (res.code == 200) {
          this.noticeList = res.data[0]
          this.newsList = res.data[1]
        }
      })
    },
    //查看首页资讯，通知----登录
    getInfoByToken() {
      getInfoByToken().then(res => {
        if (res.code == 200) {
          this.noticeList = res.data[0]
          this.newsList = res.data[1]
        }
      })
    },
    //产品-登录
    getProductByToken(params) {
      getProductByToken(params).then(res => {
        if (res.code == 200) {
          var arr = []
          res.rows.forEach((item, index) => {
            if (index < 4) {
              arr.push(item)
            }
          })
          this.productList = arr
        }
      })
    },
    //产品-未登录
    getProduct(params) {
      getProduct(params).then(res => {
        if (res.code == 200) {
          var arr = []
          res.rows.forEach((item, index) => {
            if (index < 4) {
              arr.push(item)
            }
          })
          this.productList = arr
        }
      })
    },
    //数据汇总--- 未登录
    getDataInfo() {
      getDataInfo().then(res => {
        if (res.code == 200) {
          this.dataList = res.data
        }
      })
    },
    //数据汇总--登录
    getDataInfoByToken() {
      getDataInfoByToken().then(res => {
        if (res.code == 200) {
          this.dataList = res.data
        }
      })
    },
    //切换
    changeBtn(n) {
      // this.btn = n
    },
    //跳转新闻详情
    toDetail(id) {
      this.$router.push({
        path: '/detail',
        query: { id: id }
      })
    },
    //更多
    toNotice() {
      this.$router.push({
        path: '/notice'
      })
    },
    // 查看详情
    checkDetail(id) {
      this.$router.push({ path: '/product_detail', query: { id: id, code: null } })
    },
  }
}
</script>
<style lang="less">
.bh-box {}

.bh-title {
  color: #415271;
  font-weight: bold;
  font-size: 28px;
  text-align: center;
}

.bh-intro {
  text-align: center;
  color: #767C8C;
  margin: 0 auto;
  font-weight: bold;
}

.swiper-container {
  width: 100%;
  height: 400px;
}

.swiper-container .swiper-wrapper {
  height: 400px !important;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  height: 430px !important;
  box-shadow: 0 0 10px 10px #EEF1F5;
  transition: 300ms;
  transform: scale(0.8);
  border-radius: 10px 10px 0 0;
}

.swiper-slide .big {
  width: 50%;
  margin: 10px auto 0;
}

.swiper-slide .big img {
  width: 40px;
  height: 40px;
}

.swiper-slide .title {
  color: #415271;
  font-weight: bold;
  font-size: 18px;
}

.swiper-slide .cont {
  font-size: 12px;
  color: #818695;
  margin: 5px auto;
}

.swiper-slide .detail {
  font-size: 13px;
  color: #838897;
  line-height: 24px;
  padding: 0 20px;
  text-align: justify;
  // display: none;
}

.swiper-slide .apply {
  width: 100%;
  box-sizing: border-box;
  background: #405FC4;
  padding: 15px;
  color: #fff;
  font-size: 16px;
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 0 0 10px 10px;
  // display: none;
  z-index: 9999;
}

.swiper-slide .apply span {
  margin-right: 90px;
}

.swiper-slide .apply:hover {
  cursor: pointer;
}

.swiper-slide .small {
  width: 50%;
  margin: 0 auto;
}

.swiper-slide .small img {
  width: 50px;
  height: 50px;
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translate(-50%, -50%);
}

.swiper-slide-active,
.swiper-slide-duplicate-active {
  // transform: scale(1);
  // height: 600px !important; 
  border-radius: 10px;
}

.swiper-slide-active .detail,
.swiper-slide-active .apply,
.swiper-slide-duplicate-active .detail,
.swiper-slide-duplicate-active .apply {
  display: block;
}

.index-containter {
  background: #F0F2F5;
  min-height: 100vh;

  .index-body {
    .notice {
      display: flex;
      justify-content: space-between;
      width: 100%;
      background: #011A40;
      padding: 10px 20%;
      color: #D7A804;
      font-size: 16px;
      box-sizing: border-box;
      align-items: center;

      div {
        img {
          width: 15px;
          height: 15px;
          margin-right: 10px;
        }

        span {
          span {
            text-decoration: underline;
          }

          span:hover {
            cursor: pointer;
          }
        }
      }

      .more {
        text-decoration: underline;
      }

      .more:hover {
        cursor: pointer;
      }
    }

    // padding: 20px 0;
    .index-bond {
      // margin-bottom: 20px;
      position: relative;

      .title {
        color: #fdfdfd;
        font-size: 40px;
        font-weight: 900;
        padding-bottom: 25px;
        position: absolute;
        left: 20%;
        top: 70px;
      }

      .des {
        font-size: 30px;
        color: #a2b4f2;
        font-weight: 600;
        padding-bottom: 30px;
        position: absolute;
        left: 20%;
        top: 140px;
      }

      .el-carousel__item.one {
        background: url('./../assets/1.png')no-repeat 0 0;
        background-size: auto 100%;
        background-position: center center;
      }

      .el-carousel__item.two {
        background: url('./../assets/2.png')no-repeat 0 0;
        background-size: auto 100%;
        background-position: center center;
      }

      .el-carousel__item.three {
        background: url('./../assets/3.png')no-repeat 0 0;
        background-size: auto 100%;
        background-position: center center;
      }

      .el-carousel__container {
        height: 550px;
        background: #152467;
      }

      img {
        width: 100%;
      }
    }

    .containter {
      .index-notice {
        background: #F5F6FA;
        padding: 10px;
        box-sizing: border-box;
        position: relative;

        .notice-title {
          margin-right: 40px;

          img {
            width: 40px;
            margin-right: 5px;
          }

          .title {
            color: #1890FF;
            font-size: 20px;
            font-weight: bold;
          }

          .txt {
            color: #1890FF;
            font-size: 10px;
          }
        }

        .notice-list {
          width: 75%;

          .notice-item {
            display: inline-block;
            width: 50%;
            white-space: nowrap;

            img {
              width: 20px;
              vertical-align: middle;
            }

            .title {
              display: inline-block;
              width: 65%;
              font-size: 14px;
              color: #5C5758;
              margin: 0 40px 0 10px;
              vertical-align: middle;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              word-break: break-all;
            }

            .time {
              font-size: 12px;
              color: #B8B9BA;
              vertical-align: middle;
            }
          }

          .notice-item:nth-child(1),
          .notice-item:nth-child(2) {
            margin-bottom: 5px;
          }

          .notice-item:hover {
            cursor: pointer;
          }
        }

        .notice-more {
          color: #1890FF;
          font-size: 12px;
          position: absolute;
          right: 20px;
        }

        .notice-more:hover {
          cursor: pointer;
        }
      }

      .index-use {
        margin-top: 30px;

        .index-txt {
          color: #5A5A5A;
        }

        .index-line {
          width: 45%;
          height: 1px;
          background: #E8E8E8;
        }
      }

      .index-btns {
        padding: 30px 20%;

        .btn {
          border: 1px solid #D9D9D9;
          background: #fff;
          width: 280px;
          text-align: center;
          height: 60px;
          line-height: 60px;
          border-radius: 5px;
          color: #5A5A5A;
          font-size: 18px;
        }

        .btn:hover {
          cursor: pointer;
        }

        .active {
          background: #1890FF;
          border-block: #1890FF;
          color: #fff;
        }
      }

      .index-product {
        margin: 20px 0 0;
        width: 100%;

        .product-item {
          display: inline-block;
          border: 1px solid #DCDCDC;
          text-align: center;
          width: 24%;
          height: 280px;
          padding: 0 16px;
          transition: all .15s linear;
          vertical-align: top;
          box-sizing: border-box;
          margin-bottom: 20px;
          position: relative;

          div:first-child {
            width: 100%;
            height: 80px;
            text-align: center;
            position: relative;

            img {
              width: 70%;
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
            }
          }

          .text {
            font-size: 15px;
            color: #666;
            line-height: 24px;
            overflow: hidden;
            margin-top: 5px;
            text-align: left;
          }

          span {
            box-sizing: border-box;
            display: block;
            margin: 0 auto;
            width: 80px;
            text-align: center;
            height: 30px;
            line-height: 28px;
            border-radius: 25px;
            margin-top: 25px;
            font-size: 14px;
            color: #2979dc;
            border: 1px solid #2979dc;
            transition: all .15s linear;
            position: absolute;
            bottom: 20px;
            left: 50%;
            transform: translateX(-50%);
          }

          span:hover {
            cursor: pointer;
            color: #fff;
            background: #2979dc;
          }
        }

        .product-item:hover {
          border-color: #2979dc;
          box-shadow: 0 0 10px #E7ECF2;
        }

        .product-item:nth-child(4n+2) {
          margin: 0 1.33%;
        }

        .product-item:nth-child(4n+3) {
          margin-right: 1.33%;
        }
      }

      .index-data {
        width: 100%;
        background: #fff;
        box-sizing: border-box;

        .data-head {
          text-align: center;

          img {
            width: 30px;
            margin-top: 5px;
          }
        }

        .data-analysis {
          text-align: center;

          p {
            font-size: 20px;
            margin: 0;
            color: #181818;
            font-weight: 540;
            letter-spacing: 2px;
          }

        }

        .data-des {
          text-align: center;
          font-size: 12px;
        }

        .data-list {
          padding: 40px 15% 0;

          .data-item {
            text-align: center;

            img {
              width: 80%;
            }

            .num {
              font-size: 30px;
              margin: 10px 0 0;
            }
          }
        }
      }

      .index-guarantee {
        img {
          width: 100%;
          float: left;
        }
      }
    }
  }

  .news-list {
    position: relative;

    .news-title {
      text-align: center;
      padding: 10px 0;

      .news-big-title {
        color: #333;
        font-size: 16px;
        font-weight: bold;
      }

      .news-sub-title {
        justify-content: center;
        font-size: 12px;
        padding: 5px 0;

        .line {
          display: inline-block;
          width: 10px;
          height: 1px;
          background: #7f7f7f;
        }

        span:nth-child(2) {
          padding: 0 5px;
        }
      }
    }

    .news-item-box {
      display: inline-block;
      width: 50%;
      box-sizing: border-box;
    }

    .news-item {
      margin-bottom: 10px;

      .news-left {
        width: 80px;
        height: 80px;
        border-radius: 2px;
        box-sizing: border-box;
        background: #BFBFBF;
        color: #FFFFFF;
        position: relative;
        margin-right: 15px;

        .news-left-box {
          text-align: center;
          white-space: nowrap;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);

          .news-item-day {
            font-size: 20px;
            margin-bottom: 2px;
          }

          .news-item-year {
            font-size: 14px;
          }
        }
      }

      .news-right {
        padding-right: 10px;
        box-sizing: border-box;
        width: 85%;

        .news-item-title {
          font-size: 16px;
          color: #333;
          margin-bottom: 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
        }

        .news-item-des {
          color: #999;
          font-size: 12px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
      }
    }

    .news-item:hover {
      cursor: pointer;
    }
  }
}
</style>
